import { Navigate } from "react-router-dom";

import { useAuth } from "../../contexts/auth";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/entrar" />;
  }

  return children;
};
